<template>
  <!--
    作者：kmdshop
    时间：2020-06-25
    描述：插件中心-限时秒杀-秒杀活动-添加活动
  -->
  <div class="pb50">
    <el-form size="small" ref="form" :model="form" label-width="150px">
     <!--商品信息-->
      <Info></Info>
      <!--活动时间-->
      <Basic></Basic>
    </el-form>

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" @click="cancelFunc">取消</el-button>
      <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
    </div>
  </div>
</template>
<script>
import CodeBatchApi from '@/api/codebatch.js';
import Basic from './part/Basic.vue';
import Info from './part/Info.vue';
export default {
  components: {
    /*基础设置*/
     Basic,
    /*商品信息*/
     Info

  },
  data() {
    return {
      /*表单对象*/
      form: {
        /*商品ID*/
        product_id: 0,
        /*批次名称*/
        title: '',
        /*商品名称*/
        product_name: '',
        /*规则*/
        rule: 'birthday',
        /*规格开始*/
        rule_start: 1,
        /*规格结束*/
        rule_end: 999,
        /*码前缀*/
        prefix: '',
        /*是否补零*/
        is_zeroize: 0,
        /*补零数量*/
        zero_number:0,
        /*是否批量*/
        is_batch:false,
        /*添加时间*/
        add_time:'',
        /*商品表格*/
        tableData: []
      },
      /*是否正在加载*/
      loading: false
    };
  },
  provide: function() {
    return {
      form: this.form,
      type: 'add'
    };
  },
  created() {
     if (this.$route.query.product_id != null) {
      this.form.product_id = this.$route.query.product_id;
      this.getData();
    }
  },
  methods: {
     getData() {
      let self = this;
      CodeBatchApi.getDetail(
        {
          product_id: self.form.product_id
        },
        true
      ).then(res => {
        Object.assign(self.form, res.data.model);
        self.creatSpec();
        self.loading = false;
      });
    },
    /*格式规格表格数据*/
    creatSpec() {
      let self = this;
        let obj = {
          product_name: self.form.product_name,
          product_id: self.form.product_id,
          product_price: self.form.product_price,
          stock_num: self.form.product_stock,
          product_sku_id: self.form.product_sku.product_sku_id,
          sales_num: 0,
          spec_type: self.form.spec_type,
          point_price: null,
          point_money:0,
          point_stock: 0,
          point_num: 0,
          sort: 100,
          tempProduct: true,
          is_delete: 0,
          point_product_id:0,
          point_product_sku_id: 0,
          sales_initial:0
        };
        self.form.tableData.push(obj);
    },
    /*提交表单*/
    onSubmit() {
      let self = this;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.form.product_list = self.tableFormet(self.form.tableData);
          let params = self.form;
          delete params.tableData;
          self.loading = true;
          CodeBatchApi.addBacth(params, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '恭喜你，添加成功',
                type: 'success'
              });
              self.cancelFunc();
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*表格数据格式化*/
    tableFormet(list) {
      let spec_list = [];
      let newList = [];
      let curItem = null;
      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        let obj = {
          product_sku_id: item.product_sku_id,
          seckill_stock: item.seckill_stock,
          seckill_price: item.seckill_price,
          product_attr: item.spec_name,
          seckill_product_sku_id:item.seckill_product_sku_id,
          product_price: item.product_price,
          sales_initial:item.sales_initial
        };
        if (curItem == null) {
          curItem = item;
        }
        if (curItem.product_id != item.product_id) {
          curItem.spec_list = spec_list;
          newList.push(curItem);
          curItem = item;
          spec_list = [];
        }
        spec_list.push(obj);
      }
      curItem.spec_list = spec_list;
      newList.push(curItem);
      return newList;
    },

    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/codebatch/add.vue